class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('#CartDrawer-Overlay').forEach(node=>{
      node.addEventListener('click', this.close.bind(this));
    })
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelectorAll('#cart-icon-bubble');
    cartLink.forEach(cartOpener => {
      cartOpener.setAttribute('aria-haspopup', 'dialog');
      cartOpener.setAttribute('role', 'button');
      cartOpener.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartOpener);
      });
      cartOpener.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartOpener);
        }
      });
    })
  }

  open(triggeredBy) {
    const newNavDrawer = document.querySelector('div.new-nav-drawer .nav-drawer-container')

    // if another search have been clicked, close the new drawer if it's open and is not the one into the nav drawer
    if(newNavDrawer && newNavDrawer.hasAttribute('open')) {
      document.querySelector('div.new-nav-drawer .nav-drawer-container').removeAttribute('open');
      document.querySelector('.section-header').classList.remove('menu-open')
    };
    
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
      

        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    // here should be the problem with the focus trap when an item is removed
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.querySelectorAll(`#${section.id}`);


      if (NodeList.prototype.isPrototypeOf(sectionElement)) {
        sectionElement.forEach((element) => {
          element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
        return;
      }else{
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      // Initialize free shipping progress after cart drawer opens
      if (window.FreeShippingProgress) {
        window.FreeShippingProgress(this).init();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    const sectionId = this.closest('section').id.replace('shopify-section-', '');

    return [
      {
        id: sectionId,
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);
